import {defineMessages} from 'react-intl';

export default defineMessages({
	confirmButton: {
		id: 'forms.confirm',
		defaultMessage: 'Confirmation'
	},
	selectCountry: {
		id: 'flyouts.countrySelectorFlyout.heading',
		defaultMessage: 'Change Country'
	},
	orderBilledLabel: {
		id: 'flyouts.countrySelectorFlyout.orderBilledLabel',
		defaultMessage: 'Order billed in'
	},
	selectLanguage: {
		id: 'flyouts.languageSelectorFlyout.heading',
		defaultMessage: 'Change Language'
	},
});
